const { connect } = require('react-redux');
const rankingComponent = require('../component/rankingComponent').default;
const { actions: { modalDisable } } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    return {
        isModalOpen: state.screenState.modal === modalType.MODAL_RANKING
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleBackClick: () => {
            dispatch(modalDisable());
        }
    };
};

export const RankingContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(rankingComponent);